import { fetchTopLocalLow } from '@/Groups/Scanner/private/api/widgetTopLocalLow';

const state = () => ({
  isReady: false,
  list: [],
  initImpulseId: null,
  startDate: null,
});

const actions = {
  async getWidgetData({ commit }) {
    try {
      const data = await fetchTopLocalLow(6);
      commit('SET_LIST', data.coins || []);
      commit('SET_START_DATE', data.start_date);
      if (data.impulse_id) {
        commit('SET_INIT_IMPULSE_ID', data.impulse_id);
      }
      commit('SET_IS_READY', true);
    } catch (error) {
      commit('SET_LIST', []);
      commit('SET_IS_READY', true);
    }
  },
};

const mutations = {
  SET_LIST(state, list) {
    state.list = list;
  },
  SET_IS_READY(state, flag) {
    state.isReady = flag;
  },
  SET_INIT_IMPULSE_ID(state, id) {
    state.initImpulseId = id;
  },
  SET_START_DATE(state, date){
    state.startDate = date;
  }
};

const getters = {
  list: (state) => state.list,
  isReady: (state) => state.isReady,
  initImpulseId: (state) => state.initImpulseId,
  startDate: (state) => state.startDate,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};